var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 91.493 81.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_357",
    "data-name": "\\u7EC4 357",
    transform: "translate(-37.235 838.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_145",
    "data-name": "\\u8DEF\\u5F84 145",
    d: "M82.346-757.095c-11,0-22.009.065-33.012-.021-8.294-.066-12.009-3.746-12.042-12.041q-.115-28.566,0-57.135c.033-8.3,3.743-12.021,12.033-12.047q33.645-.105,67.292,0c8.29.026,12.02,3.756,12.053,12.038q.115,28.568,0,57.135c-.033,8.285-3.761,11.986-12.043,12.049C105.2-757.03,93.773-757.095,82.346-757.095ZM47.712-767.7h70.323v-60.178H47.712Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_146",
    "data-name": "\\u8DEF\\u5F84 146",
    d: "M60.361-806.079v16.488l16.9-3.163c1.057,8.731-.125,10.234-7.816,10.25-18.164.038-17.012,1.6-16.953-16.457.046-14.2.009-14.2,16.886-14.006,7.757.09,8.89,1.441,7.927,10.36Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_147",
    "data-name": "\\u8DEF\\u5F84 147",
    d: "M112.78-802.625l-16.7-3.391v16.505l16.327-3.321c1.973,7.944.395,10.3-6.889,10.318-19.038.033-17.505,1.778-17.462-17.194,0-1.476-.009-2.953,0-4.429.063-7.764,1.054-8.766,8.762-8.827,2.742-.021,5.484-.029,8.226,0C112.694-812.877,113.9-811.383,112.78-802.625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.63428d3342ccbe61c52142712b072f09.svg";
export { ForwardRef as ReactComponent };